import React from 'react';

const TimelineVerticalLine: React.FC = () => {
    return (
        <div
            className="absolute left-1/2 transform -translate-x-1/2 h-full min-h-[185px] border border-blue-500 top-[4rem]"
            role="presentation"
        ></div>
    );
};

export default TimelineVerticalLine;
